import { env } from '../../../common/util'
import { OAuth2App, ShortOAuth2App } from '../../../store/auth/auth'
import {
  adminRoles,
  enterpriseAdminRoles,
  ownerRoles,
  professionalRoles,
  sidecarRoles,
  templateAdminRoles,
  unpaidOwnerRoles,
} from '../../ManageTeam/InviteRoleGroups'
import { DeltaTrialFeature } from '../../Plan/DeltaTrial/DeltaTrialFeatures'
import { createAppUpsellBody } from '../../Plan/DeltaTrial/OAuth2App/OAuth2App'
import { createAppIntegrationSuccess } from '../../Plan/DeltaTrial/OAuth2App/OAuth2AppSuccess'
import { createAppIntegrationTimeline } from '../../Plan/DeltaTrial/OAuth2App/OAuth2AppTimeline'
import { OAuth2AppUpsellFeatures } from '../../Plan/DeltaTrial/OAuth2App/OAuth2AppUpsellFeatures'
import { getUltimatePlanId } from '../../Plan/planConstants'

const BOOK_DEMO_URL = 'https://www.zocks.io/upgrade-to-ultimate?utm_medium=zocks&utm_source=in-app&utm_campaign=processdocument'

export const toBooleanSelectionMap = (allIds: string[], selectedIds: string[]) => {
  const selectedSet = new Set(selectedIds)
  return Object.fromEntries(allIds.map((id) => [id, selectedSet.has(id)]))
}

export const createDeltaTrialFeatureFromApp = (app: OAuth2App | ShortOAuth2App): DeltaTrialFeature => {
  return {
    id: `oauth2apps/${app.clientId}`,
    name: app.name,
    planId: getUltimatePlanId(),
    bookDemoLink: BOOK_DEMO_URL,
    UpsellBody: createAppUpsellBody(app.name, app.imageUrl ?? ''),
    UpsellFeatures: OAuth2AppUpsellFeatures,
    DeltaTrialTimeline: createAppIntegrationTimeline(app.name),
    DeltaTrialSuccess: createAppIntegrationSuccess(app.name),
  }
}

export interface CombinedRoleGroup {
  name: string
  roleIds: string[]
}

export const ROLE_GROUP_NAMES = {
  ADMIN_OWNER_USERS: 'Account owners and admins',
  ALL_ACCOUNT_USERS: 'Everyone',
} as const

export const COMBINED_ROLE_GROUPS: CombinedRoleGroup[] = [
  {
    name: ROLE_GROUP_NAMES.ADMIN_OWNER_USERS,
    roleIds: [adminRoles[env], ownerRoles[env], unpaidOwnerRoles[env]],
  },
  {
    name: ROLE_GROUP_NAMES.ALL_ACCOUNT_USERS,
    roleIds: [
      adminRoles[env],
      ownerRoles[env],
      unpaidOwnerRoles[env],
      enterpriseAdminRoles[env],
      professionalRoles[env],
      sidecarRoles[env],
      templateAdminRoles[env],
    ],
  },
]

export const getCoveredRoleGroups = (roleIds: string[]): CombinedRoleGroup[] => {
  return COMBINED_ROLE_GROUPS.filter((roleGroup) => {
    const groupRoleIdSet = new Set(roleGroup.roleIds)
    return roleIds.length > 0 && roleIds.every((roleId) => groupRoleIdSet.has(roleId))
  }).sort((a, b) => a.roleIds.length - b.roleIds.length)
}
